import React from 'react';
import { GenericListPage } from '../../../components/generic';
import type { EmbeddedInConfigurationHub } from '../../configuration-settings/models';
import { useAppDurations, AppDuration } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC<EmbeddedInConfigurationHub> = ({ embedded }) => (
  <GenericListPage<AppDuration>
    useData={useAppDurations}
    embedded={embedded}
    config={{
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }}
  />
);

export default List;
